<template>
    <div
        class="my-product-card"
        :data-type="type">
            <div class="card-container">
                <div class="my-card-header position-relative">
                    <div v-if="card.crosspromoter" class="badge">
                        <Icon v-b-tooltip.hover title="Active Crosspromoter" class="active-cp-badge" icon="badge"/>
                    </div>
                    <button
                        v-if="$route.params.campaignType === 'favorite'"
                        @click="onFavorite(card)"
                        class="position-absolute"
                        style="right: 0; transform: translate(-8px,8px); z-index: 100">
                            <Icon icon="favorited"/>
                    </button>
                    <Favorite
                        v-else-if="!type"
                        :card-data="card"
                        :favorite-location = "cardLocation"
                        class="position-absolute heart-icon"
                        style="right: 0; transform: translate(-8px,8px); z-index: 100"/>
                    <Thumbnail 
                        :data = "card"
                        size = "medium"
                        class-name="w-100" />
                    <div 
                        v-if="!type"
                        @click="toPartnerPage(card.id)"  
                        class="on-hover position-absolute d-flex align-items-center justify-content-center campaign-view-more">
                            <p class="p3b c16">View More</p>
                    </div>
                    <div class="card-info-banner position-absolute d-flex align-items-center">
                        <div class="banner-container  d-flex justify-content-between align-items-center">
                            <div>
                                <p class="lab c16 m-0">backers</p>
                                <p class="p2b c16 m-0">{{card.backers}}</p>
                            </div>
                            <div class="d-flex align-items-center">
                                <p
                                    v-if="card.state !== 'ended' || card.indemand"
                                    :class="{'live': card.state, 'indemand': card.indemand }"
                                    class="lab text-capitalize mb-0 mr-2">
                                        {{ card.indemand ? 'InDemand': card.state}}
                                </p>
                                <a 
                                    v-if="card.platform === 'kickstarter'" 
                                    :href="card.project_url" 
                                    target="_blank" 
                                    style="z-index: 1000" 
                                    @click="toProject"
                                    class="ks-link">
                                    <Icon width = "27" icon = "kickstarter" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="my-card-body d-flex flex-column line-clamp">
                    <p class="p3b c7 mb-0">{{card.title}}</p>
                    <p class="p1n c21 mb-0">{{card.description}}</p>
                </div>
                <div v-if="!type" class="mt-auto">
                    <CpButton :campaign="card"/>
                </div>
            </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { Favorite } from './Icons';
    import CpButton from './CpButton'
    import Icon from './Theme/Icon'
    import Thumbnail from './Theme/Thumbnail'

    export default {
        name: "Card",
        props: {
            card: Object,
            list: String,
            type: String,
            matchingCampaign: Boolean,
        },
        components: {
            Favorite,
            CpButton,
            Icon,
            Thumbnail
        },
        computed: {
            ...mapState([
                'user'
            ]),
            hidden: function () {
                return this.user && this.user.uid && this.user.uid === this.card.author_id
            },
            cardLocation(){
                switch(this.$route.name) {
                    case 'landingpage':
                        return 'Landing Page'
                    case 'Homepage': 
                        return 'Homepage Grid'
                    case 'campaigns': 
                        return 'Dashboard Favorites'
                    case 'Search': 
                        return 'Advanced Search'
                    case 'Campaign Page':
                        if(this.matchingCampaign){
                            return 'Matching Campaigns'
                        }
                        return 'Campaign Page'
                    default: 
                        return ''
                }
            }
        },
        methods: {
            onFavorite: function(data) {
                this.$sendMixpanelEvent('Favorite Clicked', {
                    'Heart Icon Location': 'Dashboard Favorites',
                    'Favorited Campaign': data.title,
                    'Is Favorited': false
                });

                this.$ga.event('Campaign', 'Favorite Click',`
                    Location: Dashboard Favorites,
                    Campaign: ${data.title},
                    Favorited: false
                `);

                this.$emit('favorite', data)
            },
            toProject(){
                this.$sendMixpanelEvent('KS Icon Clicked', {
                    'KS Icon Location': this.cardLocation,
                    'Viewed Campaign': this.card.title
                });

                this.$ga.event('Campaign', 'KS Icon Click', `
                    Location: ${this.cardLocation},
                    Campaign: ${this.card.title}
                `);
            },
            toPartnerPage: function() {
                this.$ga.event('Campaign','View More Click', `
                    Location: ${this.cardLocation},
                    Campaign: ${this.card.title}
                `)
                this.$sendMixpanelEvent('Campaign View More Clicked', {
                    'Campaign Card Location': this.cardLocation,
                    'Viewed Campaign Name': this.card.title
                });

                this.$router.push({
                    path: `/campaigns/${this.card.id}`
                })
                .catch(() => {})
            }
        },

    }
</script>

<style scoped lang="scss">
div.my-product-card[data-type="slider"] {
    background: none;
    box-shadow: none;
    border-radius: unset;
    transition: none;
    padding: 0;
    min-height: 413px;
    cursor: default;
    &:hover {
        box-shadow: none;
        transform: none;
    }
    div.card-container {
        height: auto;
        div.my-card-body {
            height: auto;
            max-height: 100px;
        }
    }
}
div.my-product-card {
    background: #FFFFFF;
    box-shadow: 0px 0px 35px rgba(154, 161, 171, 0.45);
    border-radius: 10px;
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 2px 6px -4px rgba(0, 0, 0, .2), 0 8px 10px -4px rgba(0, 0, 0, .14), 0 8px 12px 4px rgba(0, 0, 0, .05);
        transform: translateY(-2px);
    }
    cursor: pointer;
    padding: 16px;

    div.on-hover {
        display: none;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: none;
        transition: all 0.2s ease;
        z-index: 99;

        p {
            display: none;
            cursor: pointer;
        }
    }
    &:hover {
        div.on-hover {
            display: block;
            background: #00000080;

            p {
                display: block;
            }
        }
    }
    div.card-container {
        width: 100%;
        height: 495px;
        display: flex;
        flex-direction: column;

        div.my-card-header {
            height: 287px;
            border-radius: 3px;
            background: black;

            div.badge {
                position: absolute;
                z-index: 100;
                top: 8px;
                left: 8px;
                transform: scale(1.2);
                transition: all 0.2s ease;
                &:hover {
                    transform: scale(1.3);
                }
            }

            img {
                border-radius: 3px;
                max-height: 287px !important;
                height: 100%;
                object-fit: cover;
            }

            div.card-info-banner {
                width: 100%;
                height: 47px;
                background: #000000e6;
                border-bottom-left-radius: 3px;
                border-bottom-right-radius: 3px;
                bottom: 0;
                z-index: 100;

                div.banner-container {
                    width: 100%;
                    padding-left: 10px;
                    padding-right: 10px;
                }
            }
        }
        div.my-card-body {
            overflow: hidden;
            text-overflow:ellipsis;

            &.line-clamp {
                display: -webkit-box !important;
                -webkit-line-clamp: 4 !important;
                -webkit-box-orient: vertical !important;  
            }
            p {
                &:first-child {
                    margin-top: 8px;
                    line-height: 23px;
                }
                &:last-child {
                    margin-top: 8px;
                }
            }

            button {
                height: 35px;
            }
        }
    }

}

</style>